export default "__VITE_ASSET__DFzitCsb__"